// Confetti glyph sets per milestone flavor — tasteful, brief, gone in ~2.5s.
const CONFETTI_VARIANTS = {
    planes: ["\u2708\ufe0f", "\u2709\ufe0f", "\u2b50"],
    envelopes: ["\u2709\ufe0f", "\ud83d\udce8", "\u2728"],
    checks: ["\u2705", "\u2728", "\u2b50"],
    stars: ["\u2728", "\u2b50", "\ud83c\udf89"]
}

// Shared lightweight celebration: no third-party script or canvas worker needed.
export function burstMilestoneConfetti(variant = "stars") {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null
    const glyphs = CONFETTI_VARIANTS[variant] || CONFETTI_VARIANTS.stars
    const layer = document.createElement("div")
    layer.className = "milestone-confetti-layer"
    layer.setAttribute("aria-hidden", "true")
    for (let i = 0; i < 24; i++) {
        const piece = document.createElement("span")
        piece.className = "milestone-confetti-piece"
        piece.textContent = glyphs[i % glyphs.length]
        piece.style.left = `${Math.random() * 100}%`
        piece.style.animationDelay = `${Math.random() * 0.6}s`
        piece.style.animationDuration = `${1.6 + Math.random() * 0.9}s`
        piece.style.fontSize = `${0.7 + Math.random() * 0.7}rem`
        layer.appendChild(piece)
    }
    document.body.appendChild(layer)
    setTimeout(() => layer.remove(), 3200)
    return layer
}
